export default function PlannerHeader() {
  return (
    <header>
      <h2 className="p-2 pb-0 text-xl font-bold">Planificador</h2>
    </header>
  )
}
